import { Button } from '@optools/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { ComponentType, useState } from 'react';

import { DolbyMillicastCardContent } from './players/dolby/dolby-millicast-card-content';
import { Red5CardContent } from './players/red5/red5-card-content';
import { PlayerCard } from './player-card';

interface PlayerItem {
  id: string;
  label: string;
  playerType: PlayerType;
}

const enum PlayerType {
  DOLBY_IO = 'dolby-millicast',
  RED_5 = 'red-5',
}

const PLAYER_SELECT_OPTIONS: { label: string; value: PlayerType }[] = [
  {
    label: 'Red5 Player',
    value: PlayerType.RED_5,
  },
  {
    label: 'Dolby Millicast Player',
    value: PlayerType.DOLBY_IO,
  },
];

const PLAYERS: Record<PlayerType, ComponentType> = {
  [PlayerType.DOLBY_IO]: DolbyMillicastCardContent,
  [PlayerType.RED_5]: Red5CardContent,
};

export function PlayerValidatorPage() {
  const [players, setPlayers] = useState<PlayerItem[]>([]);
  const [selectedPlayer, setSelectedPlayer] = useState<string>(PLAYER_SELECT_OPTIONS[0].value);

  const handleRemovePlayer = (id: string) => {
    setPlayers((prevPlayers) => prevPlayers.filter((item) => item.id !== id));
  };

  const handleAddPlayer = (playerType: string) => {
    const label = PLAYER_SELECT_OPTIONS.find((option) => option.value === playerType)?.label ?? '';
    setPlayers((prevPlayers) => [
      ...prevPlayers,
      { id: crypto.randomUUID(), label, playerType: playerType as PlayerType },
    ]);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex gap-2">
        <Select value={selectedPlayer} onValueChange={setSelectedPlayer}>
          <SelectTrigger>
            <SelectValue placeholder="Select a player" />
          </SelectTrigger>
          <SelectContent>
            {PLAYER_SELECT_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button
          disabled={!selectedPlayer}
          onClick={() => selectedPlayer && handleAddPlayer(selectedPlayer)}>
          Add Player
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {players.map((player) => {
          const Player = PLAYERS[player.playerType];
          return (
            <PlayerCard
              key={player.id}
              cardContent={<Player />}
              label={player.label}
              onRemovePlayer={() => handleRemovePlayer(player.id)}
            />
          );
        })}
      </div>
    </div>
  );
}
